import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../core';
import { MatDialog } from '@angular/material/dialog';
import { RequestAssistanceComponent } from '../request-assistance-dialog.component';

import { Observable } from 'rxjs';

@Component({
  selector: 'bc-failed-payments-restricted',
  templateUrl: './failed-payments-restricted.component.html',
  styleUrls: ['./failed-payments-restricted.component.scss'],
  standalone: false,
})
export class FailedPaymentsRestrictedComponent implements OnInit {
  partnerBrandName$: Observable<string>;
  constructor(
    private partnerService: PartnerService,
    public dialog: MatDialog,
  ) {}
  ngOnInit(): void {
    this.partnerBrandName$ = this.partnerService.partnerBrandName$;
  }
  showAssistanceModal(): void {
    this.dialog.open(RequestAssistanceComponent);
  }
}
